export default __webpack_public_path__ + "static/media/alert.3d711e99.svg";